import { getToken } from "@qubictron/auth";
import { qubictronUrlMap } from "@qubictron/url";
import { AxiosError, AxiosInstance } from "axios";
import { INTEGRATION_APP_ORIGIN, isLocalhost } from "shared/utils/url.utils";

export const injectDataInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response.data,
    (error: AxiosError) => Promise.reject(error)
  );
};

export const injectAuthHeader = (instance: AxiosInstance) => {
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers.setAuthorization(`Bearer ${token}`);
    }
    return config;
  });
};

/** Qubictron tracking API requires `x-api-key` (401 INVALID_API_KEY without it). */
export const injectApiKeyHeader = (instance: AxiosInstance) => {
  instance.interceptors.request.use((config) => {
    if (TRACKING_API_KEY) {
      config.headers.set("x-api-key", TRACKING_API_KEY);
    }
    return config;
  });
};

export const injectSearchCustomHeader = (instance: AxiosInstance) => {
  instance.interceptors.request.use((config) => {
    config.headers.set(
      "X-Referer",
      `${isLocalhost(new URL(window.location.href).hostname) ? qubictronUrlMap.prod().origin : INTEGRATION_APP_ORIGIN}/`
    );
    return config;
  });
};
